/**
 * 로딩 상태를 설정 한다.
 * @param {*} state
 * @param {boolean} isLoading - 로딩 상태
 */
const SET_LOADING_STATE = (state, isLoading) => {
  state.isLoading = isLoading;
}

export default { SET_LOADING_STATE }
